<template>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :height="height" :width="width" v-if="list.length > 1">
        <van-swipe-item v-for="(item,index) in list" :key="item.id">
            <img :src="item.res_url.indexOf('http') >= 0 ? item.res_url : $config.assetsUrl + item.res_url" :style="{height:height,width:width}"/>
        </van-swipe-item>
    </van-swipe>
    <div v-else>
        <img :src="list[0].res_url.indexOf('http') >= 0 ? list[0].res_url : $config.assetsUrl + list[0].res_url" :style="{height:height,width:width}" v-if="list[0]"/>
    </div>
</template>

<script>
export default {
    name: "Banner",
    data(){
        return{
            list:[]
        }
    },
    props:{
        height:{
            type:String,
            default:'auto'
        },
        width:{
            type:String,
            default:'auto'
        },
        akey:{
            type:String,
            default:''
        }
    },
    mounted() {
        this.getList();
    },
    methods:{
        getList(){
            let _this = this;
            this.$http.post({
                url:'Banner/listAll',
                data:{key:this.akey},
                success(res){
                    _this.list = res;
                }
            })
        }
    }
}
</script>
